import axios from "axios";

const getPayslips = () => axios.get(`/api/payroll/payslips`);

export default getPayslips;
